"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgFlash = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M17.333 2.667 5.458 16.917c-.465.558-.698.837-.701 1.073-.003.205.088.4.247.529.184.148.547.148 1.273.148H16l-1.333 10.666 11.875-14.25c.465-.558.698-.837.701-1.073a.67.67 0 0 0-.247-.528c-.184-.149-.547-.149-1.273-.149H16z" }))); };
exports.default = SvgFlash;
//# sourceMappingURL=Flash.js.map